import React from 'react';
import PropTypes from 'prop-types';
import {GelDragDropContext} from '../GelDragDrop.utils';
import {MIN_TRASH_HEIGHT} from '../GelDragDrop.constants';
import {Icons} from '@learningblocks/exp-constants';

const {TrashCanSolid: TrashCan} = Icons;

/**
 * GelDragDrop - TrashLabel
 *  - Cell that renders the top Label
 */
export function TrashLabel(props) {
  const {state} = React.useContext(GelDragDropContext);

  const styleHeight = Math.max(MIN_TRASH_HEIGHT, state.trashRowHeight);

  const wrapperStyle = {height: `${styleHeight}px`};

  const imageWidth = styleHeight / 1.5;

  const imageStyle = {width: `${imageWidth}px`};

  const messageOpacity = props.isBright ? 1 : 0.3;

  const messageStyle = {opacity: messageOpacity};

  return (
    <div className={props.className} style={wrapperStyle}>
      <TrashCan className={`${props.className}_image`} style={imageStyle} />
      <p className={`${props.className}_message`} style={messageStyle}>
        {props.message}
      </p>
    </div>
  );
}

TrashLabel.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Message to be displayed on trash box
   */
  message: PropTypes.string,
  /**
   * Boolean to specify if the message is bright or dim
   */
  isBright: PropTypes.bool,
};

TrashLabel.defaultProps = {
  message: 'Drag extra bands here to delete',
};
